"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = {
  icon: {
    alignSelf: 'baseline',
    paddingTop: 25,
    color: _colors["default"].lightBlue
  },
  gridContainer: {
    flexWrap: 'nowrap'
  }
};
exports["default"] = _default;